import { SupplierDetailApi } from '../supplier-detail/api/supplier-detail-api';

export class SupplierApi {
    constructor(protected baseUrl: string) {
        this.SupplierDetail = new SupplierDetailApi(this.baseUrl);
    }

    public SupplierDetail: SupplierDetailApi;
}
